import React, { useEffect } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Attendance.scss";
import { Grid } from "@material-ui/core";
import { Text, SelectBox, SVG } from "sunrise-ui";
import toaster from "../../utilities/toaster";
import dateFormat from "../../utilities/dateFormat";
import { CSVLink } from "react-csv";

// ------for table--------------
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import { makeStyles } from "@material-ui/core/styles";

// --------------API----------------
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  getAdminAttendancePage,
  postUserByDesignation,
} from "../../redux/reducers";
import Loader from "../../utilities/Loader";
import NoDataScreen from "../../utilities/NoDataScreen";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { displayDate } from "../../utilities/displayDateUtils";

const useStylesForTable = makeStyles({
  table: {
    minWidth: 650,
  },
});

const Attendance = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const designation = useSelector((state: any) => state.UI.userByDesignation);
  const attendance = useSelector((state: any) => state.UI.adminAttendancePage);
  const [allProjectData, setAllProjectData] = React.useState([]);
  const [userByDesignation, setUserByDesignation] = React.useState([]);
  const [dataToDownload, setDataToDownload] = React.useState<any>([]);

  //method to capitalize the word
  const Capitalize = (str: any) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getYearList = ()=>{
    let startYear = 2020;
    let currentYear = new Date().getFullYear();
    let yearList =[];
    for(let i=startYear; i<=currentYear; i++){
      yearList.push(i)
    }
    return yearList;
  }

  useEffect(() => {
    //based on designation add all the names for user name dropdown
    try {
      if (designation !== undefined && designation.status === 1) {
        let arr: any = [];
        if (userType !== "Engineer") {
          arr = designation.data
            .filter((val: any) => val.subContractor.type === userType)
            .map((val: any) => Capitalize(val.name));
        } else {
          designation.data.forEach((val: any) => {
            arr.push(Capitalize(val.name));
          });
        }
        if (arr.length > 0) {
          toaster("success", "Users found");
        }
        setUserByDesignation(arr);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line
  }, [designation]);

  useEffect(() => {
    let arr2: any = [];
    if (allProject !== undefined) {
      let arr: any = [];
      arr = allProject;
      if (arr.length > 0) {
        arr.forEach((val: any) => {
          arr2.push(val.projectName);
        });
        setAllProjectData(arr2);
      }
    }
    // eslint-disable-next-line
  }, [allProject]);
  const userTypeData = [
    "Engineer",
    "Reinforcement",
    "Concrete",
    "Supply Labour",
  ];
  const monthData = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // ------------------for top4 selectboxes-----------------
  const [projectName, setProjectName] = React.useState("");
  const [userType, setUserType] = React.useState("");
  const [userName, setUserName] = React.useState("");
  const [userMonth, setUserMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [isAllFilled, setAllField] = React.useState(false);
  // const [reset, setReset] = React.useState(false);
  const [projectId, setProjectId] = React.useState<any>(""); //get selected project id

  //---------------For Table------------------
  // const [rows, setRows] = React.useState(engineerAttendanceData);
  const tableClasses = useStylesForTable();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [engId, setEngId] = React.useState("");
  const [type, setType] = React.useState("");
  const [allAttendance, setAllAttendance] = React.useState<any>([]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const [present, setPresent] = React.useState(0);
  const [absent, setAbsent] = React.useState(0);
  // const [result, setResult] = React.useState([]);
  // const [allMissingDates, setAllMissingDates] = React.useState<any>([]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (userName) {
      if (
        userType.toLowerCase() === "reinforcement" ||
        userType.toLowerCase() === "concrete" ||
        userType.toLowerCase() === "supply labour"
      ) {
        designation.data.forEach((val: any) => {
          if (
            userName.toLowerCase() === val.subContractor.ownerName.toLowerCase()
          ) {
            setEngId(val._id);
          }
        });
      } else {
        designation.data.forEach((val: any) => {
          if (userName.toLowerCase() === val.name.toLowerCase()) {
            setEngId(val._id);
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [userName, userType]);

//Submit
  const handleSubmit = (years: any) => {
    if (
      projectName === "" ||
      projectName === null ||
      projectName === undefined
    ) {
      toaster("warning", "Please select Project Name");
      return;
    } else if (userType === "" || userType === null || userType === undefined) {
      toaster("warning", "Please select User");
      return;
    } else if (userName === "" || userName === null || userName === undefined) {
      toaster("warning", "Please select User Name");
      return;
    } else if (
      //user select month
      userMonth === "" ||
      userMonth === null ||
      userMonth === undefined
    ) {
      toaster("warning", "Please select a Month");
      return;
    } else {
      setAllField(true);
      const selMonth = new Date(`${year}-${userMonth}-01`).toLocaleString(
        "en-US",
        {
          month: "short",
        }
      );
      // ----------calling api to get attendance-------
      let user = "";
      if (userType === "Engineer") {
        user = "engineer";
      } else if (userType === "Reinforcement") {
        user = "reinforce-contractor";
      } else if (userType === "Concrete") {
        user = "concrete-contractor";
      } else {
        user = "supply-labour-contractor";
      }
      setLoading(true);
      userType &&
        dispatch(
          getAdminAttendancePage({
            endPoint: `attendance?project=${projectId}&role=${user}&user=${engId}&month=${Capitalize(
              selMonth
            )}-${years}&limit=10&offset=0`,
          })
        ).then((res) => {
          setLoading(false);
        });
    }
  };

  React.useEffect(() => {
    if (
      year !== "" &&
      userName !== "" &&
      userMonth !== "" &&
      userType !== "" &&
      projectName !== ""
    ) {
      handleSubmit(year);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName, userMonth]);

  React.useEffect(() => {
    let arr: any = [];
    let present = 0;
    let absent = 0;
    if (attendance.status === 1) {
      if (
        userType.toLowerCase() === "reinforcement" ||
        userType.toLowerCase() === "concrete" ||
        userType.toLowerCase() === "supply labour" //if contractor move forward
      ) {
        if (attendance?.data?.data?.length > 0) {
          attendance?.data?.data?.forEach((val: any) => {
            arr.push(val);
          });
          setAllAttendance(arr);
        }
      } else {
        // if not contractor move forward here
        if (attendance?.data?.data?.length > 0) {
          attendance?.data?.data?.forEach((val: any) => {
            arr.push(val);
          });

          setAllAttendance(arr);
          arr.forEach((val: any) => {
            if (val.attendanceStatus === "PRESENT") {
              present += 1;
            } else if (val.attendanceStatus === "ABSENT") {
              absent += 1;
            }
          });
          setPresent(present);
          setAbsent(absent);
        }
      }
    }
    // eslint-disable-next-line
  }, [attendance, userType]);

  // //check for missing dates method
  // const missingDates = (arr: any) => {
  //   var result = arr
  //     .sort(function (a: any, b: any) {
  //       return Date.parse(a.date) - Date.parse(b.date);
  //     })
  //     .reduce(
  //       (function (hash) {
  //         return function (p: any, c: any) {
  //           var missingDaysNo =
  //             (Date.parse(c.date) - hash.prev) / (1000 * 3600 * 24);
  //           if (hash.prev && missingDaysNo > 1) {
  //             for (var i = 1; i < missingDaysNo; i++)
  //               p.push(new Date(hash.prev + i * (1000 * 3600 * 24)));
  //           }
  //           hash.prev = Date.parse(c.date);
  //           return p;
  //         };
  //       })(Object.create(null)),
  //       []
  //     );
  //   setResult(result);
  // };

  // //creating missing dates object
  // useEffect(() => {
  //   if (result.length === 0) {
  //     if (result.length > 0) {
  //       result.forEach((val: any) => {
  //         console.log(val)
  //         let values = new Date(val).toISOString();
  //         let format = dateFormat(values.split("T")[0]);
  //         let obj = {
  //           date: format,
  //           loginTimeStamp: "-",
  //           logoutTimeStamp: "-",
  //           attendanceType: "-",
  //           shiftTime: "-",
  //           attendanceStatus: "Absent",
  //           gpsLocation: "N/A",
  //         };
  //         setAllMissingDates((data: any) => [...data, obj]);
  //       });
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [result]);
  // console.log(allMissingDates)
  // //pushing missing dates in attendance array
  // useEffect(() => {
  //   if (allMissingDates.length > 0) {
  //     setAllAttendance((data: any) => [...data, allMissingDates]);
  //   }
  //   // eslint-disable-next-line
  // }, [allMissingDates]);
  // useEffect(() => {
  //   if (allAttendance.length > 0) {
  //     missingDates(allAttendance);
  //   }
  // }, [allAttendance]);

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userType.length > 0) {
      let type = "";
      let obj = {};
      if (userType.toLowerCase() === "engineer") {
        type = "engineer";
        setType(type);
      } else if (
        userType.toLowerCase() === "reinforcement" ||
        userType.toLowerCase() === "concrete" ||
        userType.toLowerCase() === "supply labour"
      ) {
        // eslint-disable-next-line
        {
          type = "sub-contractor";
          setType(type);
        }
      }
      obj = {
        role: type,
        // use selectedProjId for final Implementation
        projectId: projectId,
      };
      dispatch(
        postUserByDesignation({
          endPoint: `general/get-user-by-designation?category=${type}`,
          data: obj,
        })
      );
    }
    // eslint-disable-next-line
  }, [userType]);

  //get project id method
  const getProjectId = (index: any) => {
    setProjectId(allProject[index]._id);
  };

  //convert 24hr time format to 12hr format
  const tConv24 = (time: any) => {
    let hour = time?.split(":")[0];
    let min = time?.split(":")[1];
    let part = hour > 12 ? "PM" : "AM";

    min = (min + "").length === 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + "").length === 1 ? `0${hour}` : hour;

    return `${hour}:${min} ${part}`;
  };
  //----------------for downloading attendance data-----------------------
  useEffect(() => {
    const nullFilter = (item: String) => {
      return item === null ? "N/A" : item;
    };
    const downloadData = allAttendance?.map((val: any) => {
      if (val.attendanceMarkedBy) {
        return {
          Date: nullFilter(val.date),
          "Attendance Marked By": nullFilter(val.attendanceMarkedBy),
          "Shift Time": nullFilter(val.shift),
          "Labor Location": nullFilter(val.location),
          "Main Contractor Name": nullFilter(val.mainContractorRepresentative),
          "Client Representative Name": nullFilter(val.clientRepresentative),
          "Available Labour": nullFilter(val.availableLabour),
        };
      } else {
        return {
          Date: nullFilter(val.date),
          "Login Time Stamp": nullFilter(val.loginTimeStamp),
          "Logout Time Stamp": nullFilter(val.logoutTimeStamp),
          "Attendance Type": nullFilter(val.attendanceType),
          "Shift Time": nullFilter(val.shift),
          "Attendance Status": nullFilter(val.attendanceStatus),
          "Login Location": nullFilter(val.loginLocation),
          "Logout Location": nullFilter(val.logoutLocation),
        };
      }
    });
    setDataToDownload(downloadData);
  }, [allAttendance]);

  useEffect(() => {
    // setReset(true);
    setUserMonth("");
    setYear("");
    setAllAttendance([]);
    setAllField(false);
  }, [userName, userType, projectName]);

  return (
    <Sidebar>
      <Grid container className="attendance_wrapper">
        <Grid item>
          {/* --------------------top 4 selecBox-container----------------------------- */}
          <Grid className="Selectbox_container">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                {/* ------------select project--------- */}
                <SelectBox
                  data={allProjectData}
                  label="Select Project*"
                  placeHolder="Select Project"
                  value={projectName}
                  onChange={(e) => {
                    let target = { ...e };
                    setProjectName(target.target.value);
                    setUserName("");
                    setUserType("");
                    const index = allProjectData
                      ?.map((item: any) => item)
                      .indexOf(target.target.value);
                    getProjectId(index);
                  }}
                  resetVal={projectName === "" ? true : false}
                  defaultVal=""
                  changeReset={() => { }}
                  borderColor={"primary"}
                />
              </Grid>
              <Grid item xs={2}>
                {/* ------------select User Type--------- */}
                <SelectBox
                  data={projectName ? userTypeData : []}
                  label="Select User*"
                  placeHolder="Select User"
                  value={userType}
                  onChange={(e) => {
                    let target = { ...e };
                    setUserType(target.target.value);
                    setUserName("");
                  }}
                  borderColor={"primary"}
                  resetVal={userType === "" ? true : false}
                  defaultVal=""
                  changeReset={() => { }}
                />
              </Grid>
              <Grid item xs={3}>
                {/* ------------select UserName--------- */}
                <SelectBox
                  data={userByDesignation}
                  label="Select User Name*"
                  placeHolder="Select User Name"
                  value={userName}
                  onChange={(e) => {
                    let target = { ...e };
                    setUserName(target.target.value);
                  }}
                  resetVal={userName === "" ? true : false}
                  defaultVal=""
                  changeReset={() => { }}
                  borderColor={"primary"}
                />
              </Grid>
              <Grid item xs={2}>
                {/* ------------select Month--------- */}
                <SelectBox
                  data={monthData}
                  label="Select Month*"
                  placeHolder="Select Month"
                  value={userMonth}
                  resetVal={userMonth === "" ? true : false}
                  onChange={(e) => {
                    let target = { ...e };
                    setUserMonth(target.target.value);
                    setAllAttendance([]);
                    setAllField(false);
                    setYear("");
                  }}
                  borderColor={"primary"}
                  defaultVal=""
                  changeReset={() => {
                    // setReset(false);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                {/* ------------select Year--------- */}
                <SelectBox
                  data={getYearList()}
                  label="Select Year*"
                  placeHolder="Select Year"
                  value={year}
                  resetVal={year === "" ? true : false}
                  onChange={(e) => {
                    let target = { ...e };
                    setAllAttendance([]);
                    setAbsent(0);
                    setPresent(0);
                    setYear(target.target.value);
                    handleSubmit(target.target.value);  
                  }}
                  borderColor={"primary"}
                  changeReset={() => {
                    // setReset(false);
                  }}
                  defaultVal=""
                />
              </Grid>
            </Grid>
          </Grid>
          {/* -----------------------Total number present absent container------------- */}
          {projectName !== "" && isAllFilled && userType === "Engineer" ? (
            <Grid container className="mt">
              <Grid item lg={3} md={4} xs={6}>
                <Grid className="total_PA_box bg--white box--shadow p mr-1">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0"
                  >
                    <span>
                      <SVG type={"present"} />
                    </span>
                    Total Number of Present:{" "}
                    <span className="fw400">{present}</span>
                  </Text>
                </Grid>
              </Grid>
              <Grid item lg={3} md={4} xs={6}>
                <Grid className="total_PA_box bg--white box--shadow p">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0"
                  >
                    <span>
                      <SVG type={"absent"} />
                    </span>
                    Total Number of Absent:{" "}
                    <span className="fw400">{absent}</span>
                  </Text>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
          {/* -----------------attendance Tables--------------------------------------- */}
          {isAllFilled === true && userType === "Engineer" ? (
            // -----------------------Attendance table for Engineer-----------------------
            <>
              {loading ? (
                <Loader
                  color="#5f67e0"
                  loading={loading}
                  size={20}
                  height="80vh"
                />
              ) : (
                <Grid
                  container
                  className="bg--white box--shadow attendance_table mt"
                >
                  <Grid item xs={12}>
                    <Grid
                      container
                      className="d-flex v-center table_heading_box"
                    >
                      <Grid item xs={11}>
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={18}
                          className="mb0"
                        >
                          {userName} Attendance
                        </Text>
                      </Grid>
                      {allAttendance.length > 0 && <Grid item xs={1}>
                        <div className="downloadIcon_box d-flex v-center h-end pointer">
                          <CSVLink
                            data={dataToDownload}
                            filename={"UserDetails"}
                          >
                            <SVG type={"download"} />
                          </CSVLink>
                        </div>
                      </Grid>}
                    </Grid>
                    {allAttendance.length > 0 ? (
                      <TableContainer className="custom_table-container">
                        <Table
                          className={`${tableClasses.table} custom_table`}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Date
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Login Time Stamp
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Logout Time Stamp
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Attendance Type
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Shift Time
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Attendance Status
                              </TableCell>
                              <TableCell
                                className="f16 fw500 white-space-nw"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Login Location
                              </TableCell>
                              <TableCell
                                className="f16 fw500 white-space-nw"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Logout Location
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allAttendance
                              ?.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              ?.map((row: any, i: any) => (
                                <TableRow key={i}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="f14 fw400"
                                  >
                                    {row?.date && row?.date
                                      ? dateFormat(
                                        `${row?.date?.split("-")[2]}-${row?.date?.split("-")[1]
                                        }-${row?.date?.split("-")[0]}`
                                      )
                                      : "N/A"}
                                  </TableCell>
                                  <TableCell className="f14 fw400" align="left">
                                    {row.loginTimeStamp
                                      ? tConv24(row?.loginTimeStamp)
                                      : "N/A"}
                                  </TableCell>
                                  <TableCell className="f14 fw400" align="left">
                                    {row.logoutTimeStamp
                                      ? tConv24(row?.logoutTimeStamp)
                                      : "N/A"}
                                  </TableCell>
                                  <TableCell
                                    className={`f14 fw400 ${row.attendanceType === "system"
                                      ? "red"
                                      : ""
                                      }`}
                                    align="left"
                                  >
                                    {row.attendanceType === "user"
                                      ? "Self Marked"
                                      : row.attendanceType === "system"
                                        ? "System Marked"
                                        : "N/A"}
                                  </TableCell>
                                  <TableCell className="f14 fw400" align="left">
                                    {row.shift ? Capitalize(row.shift) : "N/A"}
                                  </TableCell>
                                  <TableCell
                                    className={
                                      row.attendanceStatus === "ABSENT"
                                        ? "f14 fw400 text--danger"
                                        : "f14 fw400 text--success"
                                    }
                                    align="left"
                                  >
                                    {row.attendanceStatus
                                      ? row.attendanceStatus
                                      : "N/A"}
                                  </TableCell>
                                  <TableCell className={row?.loginCoordinates?.lat ? "f14 fw400 pointer loginlocation" :"f14 fw400"} align="left">
                                    <div onClick={()=>{
                                         if(row?.loginCoordinates?.lat && row?.loginCoordinates?.long){
                                          window.open(`https://maps.google.com/?q=${row?.loginCoordinates?.lat},${row?.loginCoordinates?.long}`);
                                         }
                                    }}>{row.loginLocation
                                      ? row.loginLocation
                                      : "N/A"}</div>
                                  </TableCell>
                                  <TableCell className="f14 fw400" align="left">
                                    {row.logoutLocation
                                      ? row.logoutLocation
                                      : "N/A"}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={allAttendance?.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableContainer>
                    ) : (
                      <NoDataScreen text="Attendance is not marked for the selected time frame" />
                    )}
                  </Grid>
                </Grid>
              )}
            </>
          ) : isAllFilled === true && type === "sub-contractor" ? (
            //-----------------------Attendance table for contractors-------------
            <>
              {loading ? (
                <Loader
                  color="#5f67e0"
                  loading={loading}
                  size={20}
                  height="80vh"
                />
              ) : (
                <Grid
                  container
                  className="bg--white box--shadow attendance_table mt"
                >
                  <Grid item xs={12}>
                    <Grid
                      container
                      className="d-flex v-center table_heading_box"
                    >
                      <Grid item xs={11}>
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={18}
                          className="mb0"
                        >
                          {userName} Attendance
                        </Text>
                      </Grid>
                      {allAttendance.length>0 && <Grid item xs={1}>
                        <div className="downloadIcon_box d-flex v-center h-end pointer">
                          <CSVLink
                            data={dataToDownload}
                            filename={"UserDetails"}
                          >
                            <SVG type={"download"} />
                          </CSVLink>
                        </div>
                      </Grid>}
                    </Grid>
                    {allAttendance.length > 0 ? (
                      <TableContainer>
                        <Table
                          className={tableClasses.table}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Date
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Marked By
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 100 }}
                              >
                                Shift Time
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Labor Location
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 200 }}
                              >
                                Main Contractor Name
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 210 }}
                              >
                                Client Representative Name
                              </TableCell>
                              <TableCell
                                className="f16 fw500"
                                align="left"
                                style={{ minWidth: 150 }}
                              >
                                Available Labor
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allAttendance
                              ?.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              ?.map((row: any, i: any) => (
                                <TableRow key={i}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="f14 fw500"
                                  >
                                    {row?.date && row?.date
                                      ? displayDate(row?.date)
                                      : "N/A"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.attendanceMarkedBy
                                      ? row.attendanceMarkedBy
                                      : "-"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.shift ? Capitalize(row.shift) : "-"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.location ? row.location : "-"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.mainContractorRepresentative
                                      ? row.mainContractorRepresentative
                                      : "-"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.clientRepresentative
                                      ? row.clientRepresentative
                                      : "-"}
                                  </TableCell>
                                  <TableCell className="f14 fw500" align="left">
                                    {row.availableLabour
                                      ? row.availableLabour
                                      : "-"}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={allAttendance?.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableContainer>
                    ) : (
                      <NoDataScreen text="Attendance is not marked for the selected time frame" />
                    )}
                  </Grid>
                </Grid>
              )}
            </>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
      {year === "" &&
        projectName === "" &&
        userMonth === "" &&
        userName === "" && (
          <>
            <SelectOptionMsg text="Choose from the dropdowns to get the attendance details." />
            {/* <SVG type="404Error"></SVG> */}
          </>
        )}
    </Sidebar>
  );
};

export default Attendance;
